/**
 *
 *
 *
 *
 *
 */
export function assignNamespace<N, K extends keyof N>(
  parent: N,
  key: K,
  implementation: N[K],
  legacy?: Record<string, unknown>,
): N[K] {
  parent[key] = Object.assign(parent[key] ?? {}, implementation, legacy);
  return parent[key];
}
